import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconClock';
/** Renders an SVG icon. */
const SvgClock = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M13.222 2.278a14 14 0 1 1 5.555 27.444 14 14 0 0 1-5.555-27.444M18.3 4.223a12 12 0 0 0-9.002 1.823 12 12 0 0 0-5.06 12.336 12.002 12.002 0 0 0 23.538-.081 12 12 0 0 0-5.145-12.302A12 12 0 0 0 18.3 4.223"
      />
      <path
        fill="currentColor"
        d="M14.875 7a1.125 1.125 0 0 1 2.25 0v7.875H21a1.125 1.125 0 0 1 0 2.25h-5A1.125 1.125 0 0 1 14.875 16z"
      />
    </svg>
  );
};
SvgClock.displayName = displayName;
export default SvgClock;
